module.exports = __webpack_public_path__ + "img/illus-02.2befc47c.png";